"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsAndConditionsWithToggle = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _Sanitizer = require("../../base-components/Sanitizer/Sanitizer");
var _Toggle = require("../../base-components/Toggle/Toggle");
var _PropertyProvider = require("../../utils/PropertyProvider/PropertyProvider");
var _svgFetcher = _interopRequireDefault(require("../../utils/svgFetcher"));
var _TermsAndConditionsList = require("./TermsAndConditionsList");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TermsAndConditionsWithToggle = exports.TermsAndConditionsWithToggle = function TermsAndConditionsWithToggle(props, context) {
  var _mergeProps = (0, _PropertyProvider.mergeProps)('termsandconditions', props, context),
    Component = _mergeProps.Component,
    ContentComponent = _mergeProps.ContentComponent,
    header = _mergeProps.header,
    HeaderComponent = _mergeProps.HeaderComponent,
    content = _mergeProps.content,
    isOpen = _mergeProps.isOpen,
    OpenIcon = _mergeProps.OpenIcon,
    CloseIcon = _mergeProps.CloseIcon,
    toggleOnClick = _mergeProps.toggleOnClick,
    topLevelClassName = _mergeProps.topLevelClassName,
    otherContentProps = _mergeProps.otherContentProps,
    qeId = _mergeProps.qeId,
    styles = _mergeProps.styles;
  return /*#__PURE__*/_react["default"].createElement(_Toggle.Toggle, {
    Component: Component,
    toggled: isOpen,
    toggleProp: function toggleProp(_ref) {
      var toggled = _ref.toggled,
        toggleContent = _ref.toggleContent;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames2["default"])(topLevelClassName, styles.termsAndConditionsWithToggle, _defineProperty({}, styles.isOpen, toggled)),
        "data-qe-id": qeId
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: styles.header,
        tabIndex: "0",
        role: "button",
        onKeyDown: /* istanbul ignore next */function onKeyDown(event) {
          var key = event.key;
          switch (key) {
            case 'Enter':
            case ' ':
              toggleContent();
              toggleOnClick(!toggled);
              event.stopPropagation();
              event.preventDefault();
              break;
            default:
              break;
          }
        }
      }, /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
        className: styles.headerTitle,
        safelySetInnerHTML: header,
        Component: HeaderComponent,
        "aria-hidden": true
      }), /*#__PURE__*/_react["default"].createElement("button", {
        className: styles.headerButton,
        "data-qe-id": qeId,
        "aria-expanded": toggled,
        "aria-label": header,
        onClick: function onClick() {
          toggleContent();
          toggleOnClick(!toggled);
        }
      }, toggled ? /*#__PURE__*/_react["default"].createElement(OpenIcon, null) : /*#__PURE__*/_react["default"].createElement(CloseIcon, null))), /*#__PURE__*/_react["default"].createElement("div", {
        className: styles.container,
        "aria-hidden": toggled ? 'false' : 'true'
      }, /*#__PURE__*/_react["default"].createElement(ContentComponent, _objectSpread({
        content: content,
        styles: styles
      }, otherContentProps))));
    }
  });
};
TermsAndConditionsWithToggle.propTypes = {
  Component: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string]),
  ContentComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string]),
  HeaderComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string]),
  otherContentProps: _propTypes["default"].objectOf(_propTypes["default"].any),
  header: _propTypes["default"].string,
  content: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    header: _propTypes["default"].string,
    desc: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      text: _propTypes["default"].string
    }))
  })),
  isOpen: _propTypes["default"].bool,
  toggleOnClick: _propTypes["default"].func,
  namespace: _propTypes["default"].string,
  CloseIcon: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
  OpenIcon: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
  qeId: _propTypes["default"].string,
  styles: _propTypes["default"].objectOf(_propTypes["default"].string)
};
TermsAndConditionsWithToggle.defaultProps = {
  Component: 'div',
  ContentComponent: _TermsAndConditionsList.TermsAndConditionsList,
  HeaderComponent: 'h2',
  otherContentProps: {},
  header: 'Terms and Conditions',
  content: [],
  isOpen: false,
  toggleOnClick: function toggleOnClick() {},
  topLevelClassName: 'acq-terms-and-conditions-with-toggle',
  namespace: '',
  CloseIcon: function CloseIcon() {
    return (0, _svgFetcher["default"])('dls-icon-plus-circle', 'us-commercial');
  },
  OpenIcon: function OpenIcon() {
    return (0, _svgFetcher["default"])('dls-icon-minus-circle', 'us-commercial');
  },
  qeId: undefined,
  styles: {}
};
TermsAndConditionsWithToggle.contextTypes = {
  withProps: _propTypes["default"].func
};